import UserRecycle from '@/pages/user/recycle.vue'
import UserCollect from '@/pages/user/collect.vue'
const routes = [
  {
    path: '/userRecycle',
    name: 'UserRecycle',
    component: UserRecycle,
  },
  {
    path: '/userCollect',
    name: 'userCollect',
    component: UserCollect,
  },
];
export default routes